import { render, staticRenderFns } from "./data_list_notification_component.vue?vue&type=template&id=6b359727&scoped=true&"
import script from "./data_list_notification_component.vue?vue&type=script&lang=js&"
export * from "./data_list_notification_component.vue?vue&type=script&lang=js&"
import style0 from "./data_list_notification_component.vue?vue&type=style&index=0&id=6b359727&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b359727",
  null
  
)

export default component.exports